import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { ListItem } from '@/components/ui/ListItem';
import { paths } from '@/routes/paths';

export function SettingsPoliciesPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('settings.privacy')} />
        <ListItem
          title={t('settings.user_agreement')}
          onClick={() => navigate(paths.settingsPolicyView('agreement'))}
        />
        <ListItem
          title={t('settings.privacy_policy')}
          onClick={() => navigate(paths.settingsPolicyView('privacy'))}
        />
      </PageContainer>
    </AppShell>
  );
}
